import styled from 'styled-components/macro';
import {spacing, palette} from '@mui/system';

import {
  Typography as MuiTypography,
  Divider as MuiDivider,
  Stack,
  TableRow,
  Grid,
} from '@mui/material';

const Typography = styled(MuiTypography)(spacing, palette);
const Divider = styled(MuiDivider)(spacing);
const StyledStack = styled(Stack)`
  margin-right: 10px;
`;
const StyledTableRow = styled(TableRow)``;

const StyledAction = styled.div`
  display: flex;
  gap: 8px;
`;

const StyledIcon = {
  width: '18px',
  height: '18px',
};

const StyledTargetedDistributionWrapper = styled(Grid)`
  & .btn__create--voucher {
    color: #644b9f;
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    font-weight: bold;
    cursor: pointer;
  }

  & .btn__submit--form {
    width: fit-content;
  }
`;

const StyledUploadFileSection = styled(Grid)`
  display: flex;
  flex-basic: 1 3 1;
  border: 1px solid #b4b4b4;
  align-items: center;
  margin-bottom: 6px;
  max-width: 430px;
  & > div:first-child {
    background-color: #b4b4b4;
    & > img {
      padding: 28px;
    }
  }

  & > div:nth-child(2) {
    margin: auto;
    margin-left: 24px;
    & > p:first-child {
      margin-bottom: 6px;
    }
  }

  & > div:last-child {
    & > img {
      display: block;
      margin: auto;
      padding: 0px 24px;
      cursor: pointer;
    }
  }
`;

const StyledErrorMessage = styled.p`
  font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol';
  font-weight: 400;
  font-size: 0.6964285714285714rem;
  line-height: 1.66;
  text-align: left;
  margin-top: 4px;
  margin-right: 14px;
  margin-bottom: 0;
  color: #d32f2f;
  margin-left: 0;
`;

export {
  Typography,
  Divider,
  StyledStack,
  StyledTableRow,
  StyledAction,
  StyledIcon,
  StyledUploadFileSection,
  StyledErrorMessage,
  StyledTargetedDistributionWrapper,
};
